import { Injectable, inject } from '@angular/core'
import { Action, Store, select } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as MenuItemsSelectors from './menu-items.selectors'

@Injectable({
  providedIn: 'root',
})
export class MenuItemsFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  loaded$ = this.store.pipe(select(MenuItemsSelectors.selectMenuItemsLoaded))
  allMenuItems$ = this.store.pipe(select(MenuItemsSelectors.selectAllMenuItems))
  selectedMenuItem$ = this.store.pipe(select(MenuItemsSelectors.selectEntity))
  editCreateLoaded$ = this.store.pipe(select(MenuItemsSelectors.selectEditCreateLoaded))
  resourcesLoaded$ = this.store.pipe(select(MenuItemsSelectors.selectResourcesLoaded))

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
